import { FC } from 'react';

import { IconProps } from './types';

export const AiIcon: FC<IconProps> = ({ color = '#06519E', height = 19, size, width = 20 }) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 19 20"
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M7.778 2.879c.144 2.448.864 4.32 2.16 5.617 1.297 1.297 3.17 2.017 5.618 2.16-2.448.145-4.32.865-5.617 2.162-1.297 1.296-2.017 3.168-2.16 5.617-.139-2.455-.856-4.33-2.152-5.627C4.33 11.512 2.455 10.795 0 10.657c2.449-.144 4.321-.864 5.618-2.16 1.296-1.297 2.016-3.17 2.16-5.618ZM15.657 0c.065 1.113.393 1.964.982 2.553.59.59 1.44.917 2.553.983-1.113.065-1.964.392-2.553.982-.59.589-.917 1.44-.982 2.553-.063-1.116-.389-1.968-.978-2.558-.59-.589-1.442-.915-2.558-.977 1.113-.066 1.964-.393 2.554-.983.589-.589.916-1.44.982-2.553Z"
		/>
	</svg>
);
